import { render } from "./Datagrid.vue?vue&type=template&id=e37ba024&scoped=true"
import script from "./Datagrid.vue?vue&type=script&lang=js"
export * from "./Datagrid.vue?vue&type=script&lang=js"

import "./Datagrid.vue?vue&type=style&index=0&id=e37ba024&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e37ba024"]])

export default __exports__